// 订单列表Form表单的枚举值
// 分阶状态
export const StepStatusInfo = [
  { id: "1", name: "尾款未付" },
  { id: "2", name: "尾款已付" }
];

// 确认函枚举
export enum EMail {
  no = "0",
  yes = "1"
}

// 确认函
export const MailInfo = [
  { id: EMail.no, name: "未发" },
  { id: EMail.yes, name: "已发" }
];

// 获取确认函汉字
export const getMailStr = enumVal => {
  for (const item of MailInfo) {
    if (item.id === (enumVal.toString() as EMail)) {
      return item.name;
    }
  }
  return "-";
};

// 即时确认
export const Immediate = [{ id: "1", name: "是" }, { id: "0", name: "否" }];

// 目的地
export const Destination = [
  { id: "1", name: "海外店泰国" },
  { id: "2", name: "海外店新目的地的" },
  { id: "3", name: "丽江店" }
];

export enum EOrderStatus {
  daiwanshan = 0,
  yiwanshan = 1,
  yudingshenhe = 2,
  xiadanduilie = 3,
  yudingxiadan = 4,
  yudingchudan = 5,
  yudingmanyuan = 6,
  xiugaizhong = 7,
  xiugaishenhe = 8,
  xiugaixiadan = 9,
  xiugaichudan = 10,
  xiugaimanyuan = 11,
  tuidingzhong = 12,
  tuidingxiadan = 13,
  tuidingwancheng = 14,
  tuidingshibai = 15,
  yihebing = 16,
  yudingwanjie = 17,
  xiugaiwanjie = 18
}

// 订单状态
export const OrderStatus = [
  { name: "待完善", id: EOrderStatus.daiwanshan },
  { name: "已完善", id: EOrderStatus.yiwanshan },
  { name: "预订审核", id: EOrderStatus.yudingshenhe },
  { name: "下单队列", id: EOrderStatus.xiadanduilie },
  { name: "预订下单", id: EOrderStatus.yudingxiadan },
  { name: "预订出单", id: EOrderStatus.yudingchudan },
  { name: "预订满员", id: EOrderStatus.yudingmanyuan },
  { name: "修改中", id: EOrderStatus.xiugaizhong },
  { name: "修改审核", id: EOrderStatus.xiugaishenhe },
  { name: "修改下单", id: EOrderStatus.xiugaixiadan },
  { name: "修改出单", id: EOrderStatus.xiugaichudan },
  { name: "修改满员", id: EOrderStatus.xiugaimanyuan },
  { name: "退订中", id: EOrderStatus.tuidingzhong },
  { name: "退订下单", id: EOrderStatus.tuidingxiadan },
  { name: "退订完成", id: EOrderStatus.tuidingwancheng },
  { name: "退订失败", id: EOrderStatus.tuidingshibai },
  { name: "已合并", id: EOrderStatus.yihebing },
  { name: "预订完结", id: EOrderStatus.yudingwanjie },
  { name: "修改完结", id: EOrderStatus.xiugaiwanjie }
];

// 根据枚举值获取状态名称
export const getOrderStatusStr = enumVal => {
  for (const item of OrderStatus) {
    if (item.id === (Number(enumVal) as EOrderStatus)) {
      return item.name;
    }
  }
  return "-";
};

// 订单标签枚举
export enum EOrderTag {
  // 异
  yi = 1,
  // 占
  zhan = 2,
  // 急
  ji = 3,
  // 售
  shou = 4,
  // 退
  tui = 5,
  // 填
  tian = 6,
  // 测
  ce = 7,
  // 增
  zeng = 8,
  // 二
  er = 9,
  // 关
  guan = 10,
  // 阶
  jie = 11,
  // 财
  cai = 12,
  // 打包
  dabao = 13,
  // 差
  cha = 14,
  // 邮
  you = 15,
  // 群
  qun = 16,
  // 查
  cha2 = 17,
  // 赠
  give = 19,
  // 拼
  pin = 20,
  // 伙
  huo = 21
}

// 订单标签
export const OrderTag = [
  { name: "异", id: EOrderTag.yi, class: "tag-yi" },
  { name: "占", id: EOrderTag.zhan, class: "tag-zhan" },
  { name: "急", id: EOrderTag.ji, class: "tag-ji" },
  { name: "售", id: EOrderTag.shou, class: "tag-shou" },
  { name: "退", id: EOrderTag.tui, class: "tag-tui" },
  { name: "填", id: EOrderTag.tian, class: "tag-tian" },
  { name: "测", id: EOrderTag.ce, class: "tag-ce" },
  { name: "增", id: EOrderTag.zeng, class: "tag-zeng" },
  { name: "二", id: EOrderTag.er, class: "tag-er" },
  { name: "拼", id: EOrderTag.pin, class: "tag-pin" },
  { name: "伙", id: EOrderTag.pin, class: "tag-huo" },
  { name: "关", id: EOrderTag.guan, class: "tag-guan" },
  { name: "发", id: EOrderTag.guan, class: "tag-guan" },
  { name: "阶", id: EOrderTag.jie, class: "tag-jie" },
  { name: "财", id: EOrderTag.cai, class: "tag-cai" },
  { name: "打包", id: EOrderTag.dabao, class: "tag-dabao" },
  { name: "差", id: EOrderTag.cha, class: "tag-cha" },
  { name: "邮", id: EOrderTag.you, class: "tag-you" },
  { name: "群", id: EOrderTag.qun, class: "tag-qun" },
  { name: "查", id: EOrderTag.cha2, class: "tag-cha2" },
  { name: "赠", id: EOrderTag.give, class: "tag-give" }
];

// 订单交易状态一级枚举
export enum EOrderPayStatus {
  // 天猫
  tianmao = 100,
  // 商城
  shangcheng = 101,
  // 新美大
  xinmeida = 102
}

export const OrderPayStatusFirstInfo = [
  { name: "天猫", value: EOrderPayStatus.tianmao },
  { name: "商城", value: EOrderPayStatus.shangcheng },
  { name: "新美大", value: EOrderPayStatus.xinmeida }
];

// 订单交易状态二级枚举
export enum EOrderPayStatusSecond {
  // 退款中
  tuikuanzhong = 1,
  // 已退款
  yituikuan = 2,
  // 买家已付款
  maijiayifukuan = 3,
  // 卖家已发货
  maijiayifahuo = 4,
  // 交易成功
  jiaoyichenggong = 5,
  // 交易关闭
  jiaoyiguanbi = 6,
  // 等待支付
  dengdaizhifu = 7,
  // 已支付
  yizhifu = 8,
  // 已关闭
  yiguanbi = 9,
  // 等待买家付尾款
  dengdaimaijiafuweikuan = 10,
  // 卖家部分发货
  maijiabufenfahuo = 11,
  // 已支付，拼单中
  payCrowdOrdering = 12,
  // 已支付，拼单失败 
  payCrowdOrderFail = 13,
  // 已支付，拼单成功
  payCrowdOrderSuccess = 14,
}

export const OrderPayStatusSecondInfo = [
  { name: "退款中", value: EOrderPayStatusSecond.tuikuanzhong },
  { name: "已退款", value: EOrderPayStatusSecond.yituikuan },
  {
    name: "买家已付款",
    value: EOrderPayStatusSecond.maijiayifukuan
  },
  {
    name: "卖家已发货",
    value: EOrderPayStatusSecond.maijiayifahuo
  },
  {
    name: "交易成功",
    value: EOrderPayStatusSecond.jiaoyichenggong
  },
  { name: "交易关闭", value: EOrderPayStatusSecond.jiaoyiguanbi },
  { name: "等待支付", value: EOrderPayStatusSecond.dengdaizhifu },
  { name: "已支付", value: EOrderPayStatusSecond.yizhifu },
  { name: "已关闭", value: EOrderPayStatusSecond.yiguanbi },
  { name: "已支付，拼单中", value: EOrderPayStatusSecond.payCrowdOrdering },
  { name: "已支付，拼单失败", value: EOrderPayStatusSecond.payCrowdOrderFail },
  { name: "已支付，拼单成功", value: EOrderPayStatusSecond.payCrowdOrderSuccess },
  {
    name: "等待买家付尾款",
    value: EOrderPayStatusSecond.dengdaimaijiafuweikuan
  },
  {
    name: "卖家部分发货",
    value: EOrderPayStatusSecond.maijiabufenfahuo
  }
];

// 根据给定的枚举列表获取订单状态信息
const getItemFormEnums = (
  orderPayStatusEnums: Array<number>,
  nameField,
  valueField
) => {
  let list: any = [];
  for (const item of OrderPayStatusSecondInfo) {
    if (orderPayStatusEnums.indexOf(item.value) != -1) {
      let temp = {};
      temp[nameField] = item.name;
      temp[valueField] = item.value;
      list.push(temp);
    }
  }
  return list;
};

// 根据一级状态获取二级订单状态
export const getOrderStatusForFirst = (firstStastus, nameField, valueField) => {
  switch (Number(firstStastus)) {
    case EOrderPayStatus.tianmao:
      return getItemFormEnums(
        [
          EOrderPayStatusSecond.maijiayifukuan,
          EOrderPayStatusSecond.maijiayifahuo,
          EOrderPayStatusSecond.jiaoyichenggong,
          EOrderPayStatusSecond.jiaoyiguanbi,
          EOrderPayStatusSecond.dengdaimaijiafuweikuan,
          EOrderPayStatusSecond.maijiabufenfahuo
        ],
        nameField,
        valueField
      );
    case EOrderPayStatus.shangcheng:
      return getItemFormEnums(
        [
          EOrderPayStatusSecond.dengdaizhifu,
          EOrderPayStatusSecond.yizhifu,
          EOrderPayStatusSecond.yiguanbi,
          EOrderPayStatusSecond.payCrowdOrdering,
          EOrderPayStatusSecond.payCrowdOrderFail,
          EOrderPayStatusSecond.payCrowdOrderSuccess,
        ],
        nameField,
        valueField
      );
    case EOrderPayStatus.xinmeida:
      return getItemFormEnums(
        [
          EOrderPayStatusSecond.dengdaizhifu,
          EOrderPayStatusSecond.yizhifu,
          EOrderPayStatusSecond.tuikuanzhong,
          EOrderPayStatusSecond.yituikuan
        ],
        nameField,
        valueField
      );
    default:
      break;
  }
};

// 获取订单信息 nameField:新对象的名称的名称
export const getOrderPayStatus = (nameField, valueField) => {
  let obj: any = [];
  nameField = nameField || "name";
  valueField = valueField || "value";

  for (const item of OrderPayStatusFirstInfo) {
    let temp = {};
    temp[nameField] = item.name;
    temp[valueField] = item.value;
    temp["children"] = getOrderStatusForFirst(
      item.value,
      nameField,
      valueField
    );
    obj.push(temp);
  }
  // console.log("订单交易信息", obj);
  return obj;
};

// 订单列表类别
export enum EOrderListPageType {
  // 子订单列表
  "zidingdanliebiao" = 1,
  // 天猫海外店
  "tianmaohaiwaidian" = 3,
  // 分公司天猫店
  "fengongsitianmaodian" = 13,
  // 天猫丽江店
  "tianmaolijiangdian" = 4,
  // 商城
  "shangcheng" = 95
}
